import React from "react";
import Chart from "react-google-charts";


class BarChart extends React.Component {

    state = {
        data:[
            ["Question", "", { role: "style" }],
            ["correct", this.props.correctQuestion, "#66BB6A"],
            ["inCorrect", this.props.wrongQuestions, "#ef5350"],
            ["unanswered", this.props.unansweredQuestions, "#29B6F6"],
         
          ]
    }
  render() {
    return(
      <div>
        <Chart chartType="ColumnChart"
        width="100%"
        height="400px"
        data={this.state.data} 
        // horizontal={false}
        />
      </div>
    );
  }
}

const pieOptions = {
    title: "",
    pieHole: 0.6,
    slices: [
      {
        color: "#66BB6A"
      },
      {
        color: "#ef5350"
      },
      {
        color: "#29B6F6"
      },
    //   {
    //     color: "#e9a227"
    //   }
    ],
    legend: {
      position: "bottom",
      alignment: "center",
      textStyle: {
        color: "233238",
        fontSize: 14
      }
    },
    tooltip: {
      showColorCode: true
    },
    chartArea: {
      left: 0,
      top: 0,
      width: "100%",
      height: "70%"
    },
    fontName: "Roboto"
  };
  class PieChart extends React.Component {
    state = {
      chartImageURI: ""
    };
    render() {
      return (
        <div className="App">
          <Chart
            chartType="PieChart"
            data={[["TypeOfQuestions", "value", ], ["Correct", this.props.correctQuestion], ["Incorrect", this.props.wrongQuestions || 0], ["Unanswered", this.props.unansweredQuestions]]}
            options={pieOptions}
            graph_id="PieChart"
            width={"100%"}
            height={"400px"}
            legend_toggle
          />
        </div>
      );
    }
  }

  export {
      BarChart,
      PieChart
  }

